import React from "react";

import { Container } from "./styles";

const Description = ({ mb, children }) => (
  <Container mb={mb}>{children}</Container>
);

export default Description;
